(function () {
  function initCompressionGuide() {
    if (!document.body.classList.contains('c-pdp27VarA')) return;
    if (document.getElementById('c-pdp27-modal')) return;

    const fieldsets = document.querySelectorAll('.variant-picker__option');
    let compressionFieldset = null;

    fieldsets.forEach(function (fs) {
      const legend = fs.querySelector('legend');
      if (legend && legend.textContent.toLowerCase().includes('compression')) {
        compressionFieldset = fs;
      }
    });

    if (!compressionFieldset) return;

    const guideEl = document.createElement('div');
    guideEl.className = 'c-pdp27-guide';
    guideEl.innerHTML =
      'Not sure which compression level to choose? <button class="c-pdp27-guide__btn" type="button">Click Here</button>';
    compressionFieldset.insertAdjacentElement('afterend', guideEl);

    const modalEl = document.createElement('div');
    modalEl.id = 'c-pdp27-modal';
    modalEl.className = 'c-pdp27-modal';
    modalEl.setAttribute('aria-hidden', 'true');
    modalEl.innerHTML =
      '<div class="c-pdp27-modal__overlay"></div>' +
      '<div class="c-pdp27-modal__dialog" role="dialog" aria-modal="true" aria-label="Compression Guide">' +
        '<button class="c-pdp27-modal__close" type="button" aria-label="Close"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3.5 3.5L10.495 10.495" stroke="#0F0F0F" stroke-width="1.45729" stroke-linecap="round"/><path d="M10.495 3.5L3.5 10.495" stroke="#0F0F0F" stroke-width="1.45729" stroke-linecap="round"/></svg></button>' +
        '<div class="c-pdp27-modal__tabs">' +
          '<button class="c-pdp27-modal__tab c-pdp27-modal__tab--active" type="button" data-tab="standard">Standard Support<br>(15&ndash;20 mmHg)</button>' +
          '<button class="c-pdp27-modal__tab" type="button" data-tab="mild">Mild Support<br>(8&ndash;15 mmHg)</button>' +
        '</div>' +
        '<div class="c-pdp27-modal__panels">' +
          '<div class="c-pdp27-modal__panel c-pdp27-modal__panel--active" data-panel="standard">' +
            '<div class="c-pdp27-modal__panel-header">Standard Support<br>(15&ndash;20 mmHg)</div>' +
            '<div class="c-pdp27-modal__panel-body">' +
              '<ul class="c-pdp27-modal__list">' +
                '<li><strong>Best for:</strong> Nurses, long shifts, travel, swelling, and all-day leg support.</li>' +
                '<li>Provides firmer compression to help reduce fatigue, discomfort, and heavy-feeling legs.</li>' +
                '<li><strong>Choose Standard if you:</strong> Spend hours on your feet; travel often; experience swelling or tired legs.</li>' +
              '</ul>' +
            '</div>' +
          '</div>' +
          '<div class="c-pdp27-modal__panel" data-panel="mild">' +
            '<div class="c-pdp27-modal__panel-header">Mild Support<br>(8&ndash;15 mmHg)</div>' +
            '<div class="c-pdp27-modal__panel-body">' +
              '<ul class="c-pdp27-modal__list">' +
                '<li><strong>Best for:</strong> Everyday comfort, first-time wearers, and light support needs.</li>' +
                '<li>Provides gentle compression to help keep your legs feeling energized throughout the day.</li>' +
                '<li><strong>Choose Mild if you:</strong> Prefer a lighter feel; want everyday comfort and support.</li>' +
              '</ul>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modalEl);

    guideEl.querySelector('.c-pdp27-guide__btn').addEventListener('click', function () {
      openModal();
      window.igEvents = window.igEvents || [];
      window.igEvents.push({ event: 'compression_guide_click' });
    });

    modalEl.querySelector('.c-pdp27-modal__close').addEventListener('click', closeModal);
    modalEl.querySelector('.c-pdp27-modal__overlay').addEventListener('click', closeModal);

    modalEl.querySelectorAll('.c-pdp27-modal__tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (tab.classList.contains('c-pdp27-modal__tab--active')) return;

        const name = tab.dataset.tab;

        modalEl.querySelectorAll('.c-pdp27-modal__tab').forEach(function (t) {
          t.classList.toggle('c-pdp27-modal__tab--active', t === tab);
        });
        modalEl.querySelectorAll('.c-pdp27-modal__panel').forEach(function (p) {
          p.classList.toggle('c-pdp27-modal__panel--active', p.dataset.panel === name);
        });

        window.igEvents = window.igEvents || [];
        window.igEvents.push({ event: 'compression_tab_click', tab: name });
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  function openModal() {
    const modal = document.getElementById('c-pdp27-modal');
    if (!modal) return;
    modal.classList.add('c-pdp27-modal--open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    const modal = document.getElementById('c-pdp27-modal');
    if (!modal) return;
    modal.classList.remove('c-pdp27-modal--open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('DOMContentLoaded', initCompressionGuide);
  window.addEventListener('ig:ready', initCompressionGuide);
})();
